import { Container, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SessionForm from "../../components/sessions/SessionForm";
import { useSessionContext } from "../../providers/SessionProvider";
import { Id, ReSession } from "../../interfaces/types";
import { useEventContext } from "../../providers/EventProvider";
import { useCustomThemeContext } from "../../providers/customThemeProvider";


const SessionEditPage: FC = () => {
    const {sessionId} = useParams();
    const {getSessionById} = useSessionContext();
    const {getEventBySessionId } = useEventContext();
    const {updateTheme} = useCustomThemeContext();

    const [session, setSession] = useState<ReSession>();

    useEffect(() => {
        const fetchData = async () => {
            if (sessionId) {
                const sessionData = await getSessionById(sessionId as Id);
                setSession(sessionData);
                const foundEvent = await getEventBySessionId(sessionId as Id);
                if (foundEvent) {
                    updateTheme(foundEvent);
                }
            }
        };

        fetchData();
    }, [sessionId, getSessionById]);


    return (
        <Container disableGutters>
            <Typography variant="h4" align="center">
                Edit Session
            </Typography>
            <SessionForm
                submitButtonText="Update Session"
                editForm
                sessionToUpdate={session}
                //maxPresenters={3} //uncomment this attribute to limit the number of presenters, default (without this attribute) is 2 presenters
            />
        </Container>
    );
};

export default SessionEditPage;